import "./Contact.css";

export default function Contact() {
  const fullAddress = "Purnay+CHS+Ltd+Kanchan+Pushpa+Complex+Ghodbunder+Road+Thane";
  return (
    <div className="contact" id="contact">
      <div className="contact-left">
        <h1 className="heading">
          <span className="heading_text">C</span>ontact
        </h1>
        <h3>PREngineers (HEAD OFFICE)</h3>
        <article>
          <p>C6/204,Purnay C.H.S. Ltd</p>
          <p>Kanchan Pushpa Complex,</p>
          <p>Ghodbunder Road,</p>
          <p>Opp. Suraj Water Park ,Thane (W),</p>
          <p>INDIA</p>
          <p className="text-contact">
            Office: <a href="tel:+918369355382">+91 8369355382/90044863153</a>
          </p>
          <p className="text-contact">
            Email:{"  "}
            <a href="mailto:prcoverblocks@gmail.com">
              prcoverblocks@gmail.com
            </a>
          </p>
        </article>
      </div>
      {/* <div className="contact-right">
        <img src={require("../../images/map.png")} alt="..." />
      </div> */}
      <div className="contact-right">
  <div className="map-container shadow-lg">
    <iframe
      title="PREngineers Location"
      /* This URL specifically targets Purnay CHS Ltd on Ghodbunder Road */
      src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3158.1443371752584!2d72.96906506738146!3d19.258393237158103!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sC6%2F204%2CPurnay%20C.H.S.%20Ltd%20%20Kanchan%20Pushpa%20Complex%2C%20%20Ghodbunder%20Road%2C%20%20Opp.%20Suraj%20Water%20Park%20%2CThane%20(W)%2C!5e0!3m2!1sen!2sin!4v1775298438541!5m2!1sen!2sin" 
      width="100%"
      height="100%"
      style={{ border: 0, borderRadius: "15px" }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
</div>
    </div>
  );
}
